import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ConciergeWidget } from "@/components/ConciergeWidget";

const Home = lazy(() => import("@/pages/Home"));
const Offer = lazy(() => import("@/pages/Offer"));
const PopupBooking = lazy(() => import("@/pages/PopupBooking"));
const Join = lazy(() => import("@/pages/Join"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Admin = lazy(() => import("@/pages/Admin"));
const Rebook = lazy(() => import("@/pages/Rebook"));
const SmsOptin = lazy(() => import("@/pages/SmsOptin"));
const BarberLive = lazy(() => import("@/pages/BarberLive"));
const QrCards = lazy(() => import("@/pages/QrCards"));
const GiftCard = lazy(() => import("@/pages/Gift"));
const CityPage = lazy(() => import("@/pages/CityPage"));
const Pitch = lazy(() => import("@/pages/Pitch"));
const Express = lazy(() => import("@/pages/Express"));
const NewToSF = lazy(() => import("@/pages/NewToSF"));
const Hotels = lazy(() => import("@/pages/Hotels"));
const LaunchCity = lazy(() => import("@/pages/LaunchCity"));
const ManageBooking = lazy(() => import("@/pages/ManageBooking"));
const BookingConfirmed = lazy(() => import("@/pages/BookingConfirmed"));
const Review = lazy(() => import("@/pages/Review"));
const Boost = lazy(() => import("@/pages/Boost"));
const Membership = lazy(() => import("@/pages/Membership"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const ConciergeGate = () => {
  const { pathname } = useLocation();
  if (pathname === "/pitch" || pathname === "/boost") return null;
  return <ConciergeWidget />;
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Header />
          <main>
            <Suspense fallback={<div className="min-h-screen bg-ink" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/popup" element={<PopupBooking />} />
                <Route path="/join" element={<Join />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/rebook" element={<Rebook />} />
                <Route path="/sms-optin" element={<SmsOptin />} />
                <Route path="/barber-live" element={<BarberLive />} />
                <Route path="/cards" element={<QrCards />} />
                <Route path="/gift" element={<GiftCard />} />
                <Route path="/city/:citySlug" element={<CityPage />} />
                <Route path="/pitch" element={<Pitch />} />
                <Route path="/express" element={<Express />} />
                <Route path="/new-to-sf" element={<NewToSF />} />
                <Route path="/hotels" element={<Hotels />} />
                <Route path="/launch" element={<LaunchCity />} />
                <Route path="/move" element={<ManageBooking />} />
                <Route path="/booking/confirmed" element={<BookingConfirmed />} />
                <Route path="/review" element={<Review />} />
                <Route path="/boost" element={<Boost />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/membership/success" element={<Membership />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <ConciergeGate />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
